import { FirebaseDocRefType } from 'firebase/index'
import { State } from 'index'
import { Action, Dispatch } from 'redux'
import dexieDb from 'lib/db'
import { updateAuthBrandRefAction } from 'reducks/auth/actions'

// ブランド新規作成後に呼び出す
const updateAuthBrandRef = (brandRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const uid = getState().auth.uid
    const dexieAuth = await dexieDb.auth.get(uid)
    if (dexieAuth) {
      await dexieDb.auth.put({
        ...dexieAuth,
        brand_id: brandRef?.id,
      })
    }
    dispatch(updateAuthBrandRefAction(brandRef))
  }
}

export default updateAuthBrandRef
